import { memo } from 'react';
import { Badge, type BadgeProps } from './Badge.js';
import type { StatusBadgeTone } from './statusBadgeTone.js';

export type { StatusBadgeTone } from './statusBadgeTone.js';

export interface StatusBadgeProps extends Omit<BadgeProps, 'children' | 'tone'> {
  readonly label: string;
  readonly tone?: StatusBadgeTone;
}

/**
 * Canonical status-chip primitive (Spec1-P10 §10.5).
 * Defaults to `sm` so list/mobile cards share one size via badge tokens.
 */
export const StatusBadge = memo<StatusBadgeProps>(({
  label,
  tone = 'neutral',
  size = 'sm',
  ...rest
}) => (
  <Badge tone={tone} size={size} {...rest}>
    {label}
  </Badge>
));

StatusBadge.displayName = 'StatusBadge';
